import REILogo from "url:./rei-logo.png";
import WBLogo from "url:./wb_logo.png";
import VaultLogo from "url:./vault_logo.png";
import LoginBackground from "url:./login-background.jpeg";

export { REILogo, WBLogo, VaultLogo, LoginBackground };
